import { Geo } from "@tenderd/schema";
import { getServer } from "@tenderd/track-web-utils";
import { Button, Form, Input, Modal, message } from "antd";
import React, { useState } from 'react';
const ResetPasswordModal: React.FC<{
  email: string;
  showResetPassModal: boolean;
  setLoginPagePassword: React.Dispatch<React.SetStateAction<string>>;
  setLoginPageEmail: React.Dispatch<React.SetStateAction<string>>;
  setShowResetPassModal: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ email, setLoginPagePassword, setLoginPageEmail, setShowResetPassModal, showResetPassModal }) => {

  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: ""
  })

  const onFinish = () => {
    let errors = {
      password: "",
      confirmPassword: ""
    }

    const regex = /@mcdermott\.com$/;

    if (!password || !password.trim().length) {
      errors.password = "Please enter a password";
    }
    if (password.split("").length < 10) {
      errors.password = "Please enter a password of at least 10 characters";
    }
    if (password.split("").length < 14 && (regex.test(email))) {
      errors.password = "Please enter a password of at least 14 characters";
    }
    if (!/[A-Z]/.test(password)) {
      errors.password = "Password must contain an uppercase letter";
    }
    if (!/[a-z]/.test(password)) {
      errors.password = "Password must contain a lowercase letter";
    }
    if (!/[0-9]/.test(password)) {
      errors.password = "Password must contain a number";
    }
    if (!password.match(/[^a-z\d]+/i)) {
      errors.password = "Password must contain a special character";
    }
    if (confirmPassword !== password) {
      errors.confirmPassword = "Passwords don't match"
    }

    if (Object.values(errors).filter(a => a !== "").length > 0) {
      setErrors(errors);
      return;
    }

    getServer(Geo.UAE).auth0UpdatePassword({
      email,
      password
    }).then((result) => {
      if (result.success) {
        message.success('Password updated successfully!')
        setLoginPageEmail('');
        setLoginPagePassword('');
        setShowResetPassModal(false);
        setShowResetPassModal(false);
        setPassword('');
        setConfirmPassword('');
      } else {
        message.error(`Can't use the old password`)
      }
    }).catch((e) => {
      message.error('Something went wrong. Try again later.')
      setShowResetPassModal(false);
      setPassword('');
      setConfirmPassword('');
    })
  };

  const passNotReset = () => {
    message.warning('Password not reset. You will have to reset it once you login again.')
    setShowResetPassModal(false)
  }

  return (
    <Modal closable={false} footer={null} open={showResetPassModal}>
      <h3>Due to the 90 day password reset policy, you have to reset your password to access the Tenderd Track platform.</h3>
      <Form
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{ maxWidth: 600, marginTop: 40 }}
        onFinish={onFinish}
        autoComplete="off"
        colon={false}
      >
        <Form.Item
          validateStatus={errors.password !== "" ? "error" : undefined}
          help={errors.password}
          label="Password"
          rules={[{ required: true }]}
        >
          <Input.Password value={password} onChange={(e) => { setPassword(e.target.value) }} />
        </Form.Item>
        <Form.Item
          validateStatus={errors.confirmPassword !== "" ? "error" : undefined}
          help={errors.confirmPassword}
          label="Confirm Password"
          rules={[{ required: true }]}
        >
          <Input.Password value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button style={{ marginRight: 8, marginTop: 10 }} type="primary" htmlType="submit">
            Submit
          </Button>
          <Button onClick={passNotReset} htmlType="button">
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ResetPasswordModal